module.exports = __webpack_public_path__ + "img/1524480104.e3d8cda9.jpg";